import { ChannelName } from '../../../../learnware/LearnwareEnums';
import { MediaChannel } from '../MediaChannel';
export class ChannelSound extends MediaChannel {
    channelName = ChannelName.Sound;
}
